export const APP_INIT = 'APP_INIT';
export const APP_SHUTDOWN = 'APP_SHUTDOWN';
export const ETH_FEE_UPDATED = 'ETH_FEE_UPDATED';
export const ETH_FEE_UPDATE_FAILED = 'ETH_FEE_UPDATE_FAILED';
export const CAT_FEE_UPDATED = 'CAT_FEE_UPDATE';
export const CAT_FEE_UPDATE_FAILED = 'CAT_FEE_UPDATE_FAILED';
export const ACCOUNT_WALLET_RESET = 'ACCOUNT_WALLET_RESET';
export const ACCOUNT_WALLET_SELECT = 'ACCOUNT_WALLET_SELECT';
export const ACCOUNT_NOT_PROVIDED = 'ACCOUNT_NOT_PROVIDED';
export const ACCOUNT_REFRESHING = 'ACCOUNT_REFRESHING';
export const ACCOUNT_CHANGED = 'ACCOUNT_CHANGED';
export const ACCOUNT_CHANGE_FAILED = 'ACCOUNT_CHANGE_FAILED';
export const ACCOUNT_BALANCE_UPDATED = 'ACCOUNT_BALANCE_UPDATED';
export const ACCOUNT_BALANCE_UPDATE_FAILED = 'ACCOUNT_BALANCE_UPDATE_FAILED';
export const CAT_BALANCE_UPDATED = 'CAT_BALANCE_UPDATED';
export const CAT_BALANCE_UPDATE_FAILED = 'CAT_BALANCE_UPDATE_FAILED';
export const CAT_ALLOWANCE_UPDATED = 'CAT_ALLOWANCE_UPDATED';
export const CAT_ALLOWANCE_UPDATE_FAILED = 'CAT_ALLOWANCE_UPDATE_FAILED';
export const CAT_AUTHORIZATION_STARTED = 'CAT_AUTHORIZATION_STARTED';
export const CAT_AUTHORIZATION_ABORTED = 'CAT_AUTHORIZATION_ABORTED';
export const CAT_AUTHORIZATION_SUBMITTED = 'CAT_AUTHORIZATION_SUBMITTED';
export const CAT_AUTHORIZATION_FAILED = 'CAT_AUTHORIZATION_FAILED';
export const CAT_AUTHORIZATION_CONFIRMED = 'CAT_AUTHORIZATION_CONFIRMED';
export const CAT_AUTHORIZATION_REJECTED = 'CAT_AUTHORIZATION_REJECTED';
export const ACCOUNT_NETWORK_CHANGED = 'ACCOUNT_NETWORK_CHANGED';
export const ACCOUNT_NETWORK_CHANGE_FAILED = 'ACCOUNT_NETWORK_CHANGE_FAILED';
export const CAMPAIGN_CONFIGURATION_SUBMITTED = 'CAMPAIGN_CONFIGURATION_SUBMITTED';
export const CAMPAIGN_CREATE_STARTED = 'CAMPAIGN_CREATE_STARTED';
export const CAMPAIGN_CREATE_SUBMITTED = 'CAMPAIGN_CREATE_SUBMITTED';
export const CAMPAIGN_CREATE_ABORTED = 'CAMPAIGN_CREATE_ABORTED';
export const CAMPAIGN_CREATE_FAILED = 'CAMPAIGN_CREATE_FAILED';
export const CAMPAIGN_CREATE_CONFIRMED = 'CAMPAIGN_CREATE_CONFIRMED';
export const CAMPAIGN_CREATE_REJECTED = 'CAMPAIGN_CREATE_REJECTED';
export const CAMPAIGNS_FETCHED = 'CAMPAIGNS_FETCHED';
export const CAMPAIGNS_FETCH_FAILED = 'CAMPAIGNS_FETCH_FAILED';
export const CAMPAIGN_EVENTS_FETCHED = 'CAMPAIGN_EVENTS_FETCHED';
export const CAMPAIGN_EVENTS_FETCH_FAILED = 'CAMPAIGN_EVENTS_FETCH_FAILED';
export const CAMPAIGN_RESET = 'CAMPAIGN_RESET';
export const CAMPAIGN_LOCALLY_DISCARDED = 'CAMPAIGN_LOCALLY_DISCARDED';
export const CAMPAIGNS_LOCALLY_LOADED = 'CAMPAIGNS_LOCALLY_LOADED';
export const CAMPAIGN_REWARDS_GENERATED = 'CAMPAIGN_REWARDS_GENERATED';
export const TOKEN_ALLOWANCE_UPDATED = 'TOKEN_ALLOWANCE_UPDATED';
export const TOKEN_ALLOWANCE_UPDATE_FAILED = 'TOKEN_ALLOWANCE_UPDATE_FAILED';
export const TOKEN_BALANCE_UPDATED = 'TOKEN_BALANCE_UPDATED';
export const TOKEN_BALANCE_UPDATE_FAILED = 'TOKEN_BALANCE_UPDATE_FAILED';
export const TOKEN_AUTHORIZATION_STARTED = 'TOKEN_AUTHORIZATION_STARTED';
export const TOKEN_AUTHORIZATION_ABORTED = 'TOKEN_AUTHORIZATION_ABORTED';
export const TOKEN_AUTHORIZATION_SUBMITTED = 'TOKEN_AUTHORIZATION_SUBMITTED';
export const TOKEN_AUTHORIZATION_FAILED = 'TOKEN_AUTHORIZATION_FAILED';
export const TOKEN_AUTHORIZATION_CONFIRMED = 'TOKEN_AUTHORIZATION_CONFIRMED';
export const TOKEN_AUTHORIZATION_REJECTED = 'TOKEN_AUTHORIZATION_REJECTED';
export const TRANSACTION_RECEIPTS_FETCHED = 'TRANSACTION_RECEIPTS_FETCHED';
export const TRANSACTION_RECEIPTS_FETCH_FAILED = 'TRANSACTION_RECEIPTS_FETCH_FAILED';
export const REWARD_CANCEL_STARTED = 'REWARD_CANCEL_STARTED';
export const REWARD_CANCEL_SUBMITTED = 'REWARD_CANCEL_SUBMITTED';
export const REWARD_CANCEL_ABORTED = 'REWARD_CANCEL_ABORTED';
export const REWARD_CANCEL_FAILED = 'REWARD_CANCEL_FAILED';
export const REWARD_CANCEL_CONFIRMED = 'REWARD_CANCEL_CONFIRMED';
export const REWARD_CANCEL_REJECTED = 'REWARD_CANCEL_REJECTED';
export const REWARD_REDEEM_STARTED = 'REWARD_REDEEM_STARTED';
export const REWARD_REDEEM_SUBMITTED = 'REWARD_REDEEM_SUBMITTED';
export const REWARD_REDEEM_ABORTED = 'REWARD_REDEEM_ABORTED';
export const REWARD_REDEEM_FAILED = 'REWARD_REDEEM_FAILED';
export const REWARD_REDEEM_CONFIRMED = 'REWARD_REDEEM_CONFIRMED';
export const REWARD_REDEEM_REJECTED = 'REWARD_REDEEM_REJECTED';
export const LATEST_BLOCK_NUMBER_UPDATED = 'LATEST_BLOCK_NUMBER_UPDATED';
export const LATEST_BLOCK_NUMBER_UPDATE_FAILED = 'LATEST_BLOCK_NUMBER_UPDATE_FAILED';
export const TOKEN_ADDRESS_CHANGED = 'TOKEN_ADDRESS_CHANGED';
export const TOKEN_INFO_UPDATED = 'TOKEN_INFO_UPDATED';
export const TOKEN_INFO_UPDATE_FAILED = 'TOKEN_INFO_UPDATE_FAILED';
export const TOKENS_LOCALLY_LOADED = 'TOKENS_LOCALLY_LOADED';
export const CUSTOM_TOKEN_ADDED = 'CUSTOM_TOKEN_ADDED';
export const TRANSACTION_LOCALLY_DISCARDED = 'TRANSACTION_LOCALLY_DISCARDED';
export const RECOMMENDED_GAS_PRICES_UPDATED = 'RECOMMENDED_GAS_PRICES_UPDATED';
export const RECOMMENDED_GAS_PRICES_UPDATE_FAILED = 'RECOMMENDED_GAS_PRICES_UPDATE_FAILED';
export const ACCOUNT_WALLET_RELOAD_STARTED = 'ACCOUNT_WALLET_RELOAD_STARTED';
export const ACCOUNT_WALLET_RELOAD_FAILED = 'ACCOUNT_WALLET_RELOAD_FAILED';
export const ACCOUNT_WALLET_RELOAD_COMPLETED = 'ACCOUNT_WALLET_RELOAD_COMPLETED';
export const CAMPAIGN_CANCEL_STARTED = 'CAMPAIGN_CANCEL_STARTED';
export const CAMPAIGN_CANCEL_SUBMITTED = 'CAMPAIGN_CANCEL_SUBMITTED';
export const CAMPAIGN_CANCEL_ABORTED = 'CAMPAIGN_CANCEL_ABORTED';
export const CAMPAIGN_CANCEL_FAILED = 'CAMPAIGN_CANCEL_FAILED';
export const CAMPAIGN_CANCEL_CONFIRMED = 'CAMPAIGN_CANCEL_CONFIRMED';
export const CAMPAIGN_CANCEL_REJECTED = 'CAMPAIGN_CANCEL_REJECTED';



// WEBPACK FOOTER //
// ./src/actionTypes.js